// Editor styles (imported statically so Vite extracts them to CSS).
import 'tinymce/skins/ui/oxide/skin.min.css';

// Load TinyMCE in a deterministic order:
//   1. Core — its IIFE assigns `window.tinymce`
//   2. Theme / icons / plugins — they reference `tinymce` as a bare global
//
// Static imports get hoisted and evaluated in module-graph order, which
// Rolldown does not preserve across a merged vendor chunk. Dynamic imports
// force the sequence at runtime and decouple load from any bundler quirks.
let loadPromise = null;

export const loadTinymce = () => {
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    const { default: tinymce } = await import('tinymce/tinymce');
    globalThis.tinymce = tinymce;

    await Promise.all([
      import('tinymce/themes/silver'),
      import('tinymce/icons/default'),
      import('tinymce/plugins/advlist'),
      import('tinymce/plugins/autolink'),
      import('tinymce/plugins/link'),
      import('tinymce/plugins/lists'),
      import('tinymce/plugins/charmap'),
      import('tinymce/plugins/hr'),
      import('tinymce/plugins/anchor'),
      import('tinymce/plugins/spellchecker'),
      import('tinymce/plugins/searchreplace'),
      import('tinymce/plugins/wordcount'),
      import('tinymce/plugins/code'),
      import('tinymce/plugins/fullscreen'),
      import('tinymce/plugins/insertdatetime'),
      import('tinymce/plugins/nonbreaking'),
      import('tinymce/plugins/template'),
      import('tinymce/plugins/help'),
    ]);

    return tinymce;
  })();

  return loadPromise;
};
